import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import ButtonWithLoading from '../../../../../../components/ButtonWithLoading';
import useMockLoading from '../../../../../../components/Hooks/useMockLoading';
import { FeatureFlagEnum } from '../../../../../../featureflag/feature-flag.enum';
import { useFeatureFlag } from '../../../../../../hooks/useFeatureFlag';
import LangEnum from '../../../../../../lang/LangEnum';
import { OrderSummaryTestIds } from '../../../../../../utils/testIds/OrderSummary.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useOrderEditSectionsContext } from '../../../sections/OrderEditSections.context';
import OrderValidationErrors from '../../../validate/OrderValidationErrors';
import { getOrderSummaryActionButtonStyles } from './orderSummaryActions.styles';

interface SuggestedOrderActionButtonProps {
  onClick: () => Promise<void>;
  canEditOrder: boolean;
}

const SuggestedOrderActionButton = ({ onClick, canEditOrder }: SuggestedOrderActionButtonProps) => {
  const { hasOrderErrors } = useOrderEditSectionsContext();
  const { getFeatureFlag } = useFeatureFlag();
  const isDisabledButton = hasOrderErrors && !canEditOrder;
  const { handleAsyncFunction: handleClickAcceptSuggestion, isLoading } = useMockLoading({
    asyncFunction: onClick,
  });

  const isFeatureAvailable = getFeatureFlag(FeatureFlagEnum.ACCEPT_SUGGESTED_ORDER);

  const { translate } = useTranslation();

  const getButtonLabel = () => {
    if (canEditOrder) {
      return LangEnum.GLOBAL_FINISH_EDITING;
    }
    return LangEnum.SUGGESTED_ORDER_ACCEPT_SUGGESTION;
  };
  return (
    <Tooltip
      fullWidth
      disabled={!hasOrderErrors}
      TooltipContent={
        isDisabledButton ? <OrderValidationErrors isFinishOrderValidation={false} /> : ''
      }
    >
      <ButtonWithLoading
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        disabled={isDisabledButton || !isFeatureAvailable}
        onClick={handleClickAcceptSuggestion}
        isLoading={isLoading}
        test-id={OrderSummaryTestIds.CONTINUE_BUTTON}
        sx={(theme) => ({
          ...getOrderSummaryActionButtonStyles(theme),
          backgroundColor: isDisabledButton ? theme.palette.action.disabledBackground : '',
          '&:disabled': { backgroundColor: theme.palette.action.disabledBackground },
        })}
      >
        <Typography noWrap>{translate(getButtonLabel())}</Typography>
      </ButtonWithLoading>
    </Tooltip>
  );
};

export default SuggestedOrderActionButton;
